import { RichTextEditor } from "components/DesignSystem/RichTextEditor/RichTextEditor";

export const InvoiceAdditionalDetails = () => (
  <div className="t-flex t-flex-col t-gap-4">
    <RichTextEditor
      name="notes"
      label="Notes"
      placeholder="Add any additional details or information about this invoice"
    />
    <RichTextEditor
      name="payment_instructions"
      label="Payment instructions"
      placeholder="Add instructions for how and where to make the payment"
    />
    <RichTextEditor
      name="terms"
      label="Terms"
      placeholder="Add your payment terms, conditions, or other applicable terms"
    />
    <RichTextEditor
      name="footer"
      label="Footer"
      placeholder="Add a closing message or your contact details"
    />
  </div>
);
